import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const inputDefaultVariants = {
  "size": "md",
  "fullWidth": false,
  "error": false,
  "warning": false,
  "success": false,
  "ghost": false
}
const inputCompoundVariants = []

const inputSlotNames = [
  [
    "root",
    "input__root"
  ],
  [
    "inputContainer",
    "input__inputContainer"
  ],
  [
    "input",
    "input__input"
  ],
  [
    "startAdornment",
    "input__startAdornment"
  ],
  [
    "endAdornment",
    "input__endAdornment"
  ]
]
const inputSlotFns = /* @__PURE__ */ inputSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, inputDefaultVariants, getSlotCompoundVariant(inputCompoundVariants, slotName))])

const inputFn = memo((props = {}) => {
  return Object.fromEntries(inputSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const inputVariantKeys = [
  "size",
  "error",
  "warning",
  "success",
  "ghost",
  "fullWidth"
]
const getVariantProps = (variants) => ({ ...inputDefaultVariants, ...compact(variants) })

export const input = /* @__PURE__ */ Object.assign(inputFn, {
  __recipe__: false,
  __name__: 'input',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: inputVariantKeys,
  variantMap: {
  "size": [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
  ],
  "error": [
    "true"
  ],
  "warning": [
    "true"
  ],
  "success": [
    "true"
  ],
  "ghost": [
    "true"
  ],
  "fullWidth": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, inputVariantKeys)
  },
  getVariantProps
})